import { render } from "./LoadingView.vue?vue&type=template&id=12cf08d6&scoped=true"
const script = {}

import "./LoadingView.vue?vue&type=style&index=0&id=12cf08d6&lang=scss&scoped=true"

import exportComponent from "E:\\docker\\sakae\\htdocs\\sakae-race-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cf08d6"]])

export default __exports__